import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import DetaljPageHeader from "../Common/Detalj/DetaljPageHeader";
import BilderContainer from "../Common/Ileggelser/Detalj/BilderContainer";
import Ettersendelser from "../Common/Ileggelser/Detalj/Ettersendelser";
import IleggelseGridOgKommentarContainer from "../Common/Ileggelser/Detalj/IleggelseGridOgKommentarContainer";
import KlageinformasjonContainer from "../Common/Ileggelser/Detalj/KlageinformasjonContainer";
import NyeEttersendelser from "../Common/Ileggelser/Detalj/NyeEttersendelser";
import TilbakemeldingerFraBybetjenterContainer from "../Common/Ileggelser/Detalj/TilbakemeldingerFraBybetjenterContainer";
import Spinner from "../Common/Spinner";

import KopiContainer from "../Common/Ileggelser/Detalj/KopiContainer";

import Map from "../Common/Maps/MapView";

import { getBybetjenter as getBybetjenterAction } from "../../actions/bybetjenterActions";
import { getIleggelseEttersendelser as getIleggelseEttersendelserAction } from "../../actions/ileggelseEttersendelserActions";
import { getIleggelse as getIleggelseAction } from "../../actions/ileggelserActions";

import * as title from "../../constants/titles";
import KlagebehandlingInformasjonContainer from "../Common/Ileggelser/Detalj/KlagebehandlingInformasjonContainer";

export default function InnsynIleggelseDetaljPage() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const ileggelse = useSelector((state) => state.ileggelse);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = ileggelse.ileggelsesnummer
      ? title.innsynIleggelseDetalj(ileggelse.ileggelsesnummer)
      : document.title;
    dispatch(getIleggelseAction(id));
    dispatch(getIleggelseEttersendelserAction(id));
    dispatch(getBybetjenterAction());
  }, []);

  useEffect(() => {
    if (ileggelse.ileggelsesnummer) {
      document.title = title.innsynIleggelseDetalj(ileggelse.ileggelsesnummer);
    }
  }, [ileggelse.ileggelsesnummer]);

  if (ileggelse && ileggelse.id === id) {
    return (
      <div className="ileggelse-content-wrapper">
        <DetaljPageHeader
          pageName={"Ileggelse"}
          pageId={String(ileggelse.ileggelsesnummer)}
          isMakulert={ileggelse.isMakulert}
        />
        <Tabs
          defaultActiveKey={1}
          id="InnsynnIleggelseTabs"
          className="detailjTab"
          mountOnEnter
        >
          <Tab eventKey={1} title="Ileggelse">
            <div className="ileggelse-tab-content-wrapper">
              <div style={{ marginBottom: 30, marginLeft: 50 }}>
                <KopiContainer />
              </div>
              <IleggelseGridOgKommentarContainer />
              <TilbakemeldingerFraBybetjenterContainer
                ileggelseId={ileggelse.id}
              />
              <BilderContainer ileggelseId={ileggelse.id} />
              <Ettersendelser />
              <NyeEttersendelser />
              <KlageinformasjonContainer ileggelseId={ileggelse.id} />
              <KlagebehandlingInformasjonContainer ileggelseId={ileggelse.id} />
            </div>
          </Tab>
          <Tab eventKey={2} title="Kart">
            <Map lat={ileggelse.latitude} lng={ileggelse.longitude} />
          </Tab>
        </Tabs>
      </div>
    );
  }

  return (
    <div>
      <Spinner isLoading />
    </div>
  );
}
